// src/components/ResetScrollContainer.jsx
import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

const ResetScrollContainer = () => {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    const content = document.querySelector(".content-container");
    if (content) content.scrollTop = 0;
  }, [pathname]);

  return null;
};

export default ResetScrollContainer;
